import { type OpenApiSchemaAddonListItem } from '#shared/api/schema';
import { useActionEdit } from './useActionEdit';
import { useActionRemove } from './useActionRemove';

export const useAddonActions = (addonId: OpenApiSchemaAddonListItem['id'], onRemove?: VoidFunction) => {
    const { menuItem: actionRemove, renderConfirmModal } = useActionRemove(addonId, onRemove);
    const { menuItem: actionEdit } = useActionEdit(addonId);

    return {
        items: [
            {
                key: 'main',
                options: [actionEdit],
            },
            actionRemove,
        ],
        renderConfirmModal,
    };
};
